export default __webpack_public_path__ + "static/media/copy-icon.f16ab672.svg";